module.exports = __webpack_public_path__ + "static/media/ud_video.3840542.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/UnderdogDetective/top/ud_video.mp4
// module id = uoIS
// module chunks = 0